"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgSortArrows = function SvgSortArrows(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m7.798 4.207-.003-.003a1.122 1.122 0 0 0-1.59 0l-4 4a1.125 1.125 0 1 0 1.59 1.591l2.08-2.079V19a1.125 1.125 0 0 0 2.25 0V7.716l2.08 2.08a1.125 1.125 0 0 0 1.59-1.591L7.799 4.206ZM18.125 5a1.125 1.125 0 0 0-2.25 0v11.284l-2.08-2.08a1.125 1.125 0 0 0-1.59 1.591l3.999 4 .006.006a1.126 1.126 0 0 0 .347.233l.012.005a1.118 1.118 0 0 0 .862 0l.012-.005a1.117 1.117 0 0 0 .352-.238l.004-.004 3.997-3.997a1.125 1.125 0 0 0-1.591-1.59l-2.08 2.079V5Z",
    fill: "#000"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgSortArrows);
var _default = exports["default"] = Memo;